import React from "react";
import styles from "./index.module.scss";
import { renderRichText } from "@/utils/formatters";
import { useRouter } from "next/router";

const FeatureVisualizationSection = ({ featureVisualizationData }) => {
  const { locale } = useRouter();

  if (!featureVisualizationData) return null;

  const {
      heading,
      description,
      images = [],
    } = featureVisualizationData;

  return (
    <section className={styles.leapToiletTwoColumnImageSection}>
      <div className={styles.leapToiletTwoColumnImageContainer}>

        {heading && (
        <div className={styles.leapToiletTwoColumnImageTitle}>
          {heading}
        </div>
        )}

        <div className={styles.leapToiletColumnImagesPart}>
        {images.map((img) => {
            const { imageUrl, alt } = img.fields || {};
            if (!imageUrl) return null;

            return (
              <img key={img.sys.id} src={imageUrl} alt={alt || ""} />
            );
        })}
        </div>

        {description && (
        <div className={styles.leapToiletTwoColumnImageDescription}>
          {renderRichText(description, locale)}
        </div>
        )}
      </div>
    </section>
  );
};

export default FeatureVisualizationSection;
